import { render, staticRenderFns } from "./RecurringChargesTab.vue?vue&type=template&id=67f9a590"
import script from "./RecurringChargesTab.vue?vue&type=script&lang=js"
export * from "./RecurringChargesTab.vue?vue&type=script&lang=js"
import style0 from "./RecurringChargesTab.vue?vue&type=style&index=0&id=67f9a590&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports